import React, { useState, useEffect } from 'react';

const StopMotionSvg = ({ shapes, width = 200, height = 200, interval, stroke = 'var(--orange)', strokWidth = 2

}) => {
  const [currentFrames, setCurrentFrames] = useState(
    shapes.map(() => 0)
  );

  useEffect(() => {
    if (!interval)
      return;

    const id = setInterval(() => {
      setCurrentFrames((prevFrames) =>
        prevFrames.map((frameIndex, shapeIdx) => {
          const totalFrames = shapes[shapeIdx].length;
          return (frameIndex + 1) % totalFrames;
        })
      );
    }, interval);

    return () => clearInterval(id);
  }, [shapes, interval]);

  return (
    <svg className={'stop-motion-svg'}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      stroke={stroke}
      style={{ width: `calc(var(--vw) * ${width}px)` }}
    >
      {shapes.map((frames, shapeIdx) => {
        const currentPath = frames[currentFrames[shapeIdx]];
        return (
          <path
            key={shapeIdx}
            d={currentPath}
            fill={stroke}
            stroke={stroke}
            strokeWidth={strokWidth}
          />
        );
      })}
    </svg>
  );
};

export default StopMotionSvg;
